// angular dependencies
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { isDevMode, Provider } from '@angular/core';

// fantaz dependencies
import { apiEndpointsConfig } from './config';
import {
  httpAuthInterceptor,
  httpCacheInterceptor,
  httpLoggingInterceptor,
} from './interceptors';
import { provideApiEndpoints } from './utils/api-endpoints.provider';

export function provideDataAccessConfig(...providers: Provider[]): any[] {
  return [
    provideHttpClient(
      withInterceptors([
        /*
         * Provider for the HTTP authentication interceptor.
         * This interceptor adds authentication headers to outgoing HTTP requests.
         */
        httpAuthInterceptor(),

        /*
         * Provider for the HTTP cache interceptor.
         * This interceptor caches HTTP responses for a specified duration.
         */
        httpCacheInterceptor(),

        /*
         * Provider for the development mode interceptor.
         * `httpLoggingInterceptor`: This interceptor logs HTTP requests and
         *  responses to the console.
         */
        ...(isDevMode() ? [httpLoggingInterceptor()] : []),
      ]),
    ),

    /*
     * Provide the API endpoints configuration
     */
    provideApiEndpoints({
      endpoints: {
        useValue: apiEndpointsConfig,
      },
    }),

    /*
     * Provide extras providers
     */
    ...providers,
  ];
}
